module.exports = __webpack_public_path__ + "media/images/illustrations/standard_materials_boxes-f8830c63969d301cec75730ae4dcbf4e.svg";